import { useMemo } from 'react'
import Trans from 'next-translate/Trans'
import { STATUS_UNDER_NEGOTIATION } from 'tennders-stracture/libs/constants'
import GCurrency from 'tennders-market/common/components/element/GCurrency'
import DistanceInKm from 'tennders-common/components/DistanceInKM'
import { withSharedNegotiation } from 'tennders-market/common/hocs/withSharedNegotiation'
import useSession from 'tennders-auth/hooks/useSession'
import AcceptedButNotAssigned from 'tennders-market/offer/views/negotiation-for-shared/action/AcceptedButNotAssigned'
import UnderNegotiation from 'tennders-market/offer/views/negotiation-for-shared/action/UnderNegotiation'
import MPTag from 'tennders-transactions/views/common/TagMP'

const OfferLine = ({ offer, title, bold }) => {
  const line = (
    <>
      {offer?.isMyOffer
        ? <Trans i18nKey="offer:yourOffer" />
        : title}
      {' : '}
      <GCurrency value={offer?.bid} />
      {' / '}
      {offer?.paymentTerms ? (
        <>
          {`${offer?.paymentTerms}`}
          <Trans i18nKey="offer:days" />
        </>
      ) : null}
      {' / '}
      <DistanceInKm value={offer?.distance} />
      {` | ${offer?.date}`}
    </>
  )
  return (
    <div className="mb-8">
      {bold ? <strong>{line}</strong> : line}
    </div>
  )
}

const SingleOffer = (props) => {
  const {
    transaction,
    post,
    acceptOffer,
    sendBid,
    submitting,
    continueNegotiate,
    revertOffers,
    declineOffer,
    offer,
    assignOffer,
    marketPlace
  } = props
  const { isBroker } = useSession()

  const isOwner = useMemo(() => (
    marketPlace ? transaction?.isSharedWithMarketPlace : isBroker()
  ), [marketPlace, transaction?.isSharedWithMarketPlace, isBroker])

  const isGray = useMemo(() => (
    (offer?.status?.label === 'OFFER_WAITING' && !offer?.lastOffer && isOwner) || offer?.status?.label === 'OFFER_DECLINED'
  ), [offer?.status?.label, offer?.lastOffer, isOwner])

  if (!transaction?.marketPrice && transaction?.status?.label !== STATUS_UNDER_NEGOTIATION && !isOwner) {
    return null
  }

  return (
    <>
      {!isOwner && <h4 className="bold"><Trans i18nKey="offer:negotiation" /></h4>}
      <div className="mb-10 pb-10 border-b">
        <div className={'br-6 p-16' + (isGray ? ' bg-color-secondary-200' : ' bg-color-white')}>
          <div className="border-b d-flex mb-8 pb-8 align-center">
            <div className="bold">
              {post?.company?.name || `${offer?.owner}`}
            </div> {marketPlace && isBroker() && <div className="ml-8"><MPTag /></div>}
          </div>
          <div className="d-flex row align-center">
            <div className="w-50">
              {offer?.lastOffer && (
                <OfferLine
                  bold
                  offer={offer?.lastOffer}
                  title={offer?.isMyOffer ? <Trans i18nKey="offer:yourOffer" /> : offer?.lastOffer?.owner}
                />
              )}
              {offer?.offers?.map((cOffer) => (
                <OfferLine
                  key={cOffer.id}
                  bold={false}
                  offer={cOffer}
                  title={cOffer.owner}
                />
              ))}
              {offer?.firstOffer?.bid ? (
                <OfferLine
                  bold={false}
                  title={offer?.firstOffer.isMyOffer ? <Trans i18nKey="offer:yourOffer" /> : offer?.owner}
                  offer={offer?.firstOffer}
                />
              ) : null}
            </div>
            <AcceptedButNotAssigned
              marketPlace={marketPlace}
              assignOffer={assignOffer}
              declineOffer={declineOffer}
              transaction={transaction}
              offer={offer}
              acceptOffer={acceptOffer}
            />
            <UnderNegotiation
              marketPlace={marketPlace}
              submitting={submitting}
              sendBid={sendBid}
              declineOffer={declineOffer}
              transaction={transaction}
              continueNegotiate={continueNegotiate}
              revertOffers={revertOffers}
              offer={offer}
              acceptOffer={acceptOffer}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default withSharedNegotiation(SingleOffer)
